<template>
    <!--
        PRODUCT-26110 Phase 2B2: render the native element explicitly instead of
        `<component :is="simulated ? 'div' : 'form'">`. This component is named `Form`, and
        Vue 3 lets a component reference itself by name for recursion, so `:is="'form'"`
        resolved `form` -> capitalize -> `Form` -> THIS component and rendered itself
        forever (stack overflow). Vue 2 rendered the native <form> here.
    -->
    <div
        v-if="simulated"
        ref="dom"
        role="form"
        class="Form"
        @submit="$emit('submit', $event)"
    >
        <div class="Form__body">
            <slot />
        </div>
        <div v-if="$slots.buttons" class="Form__buttons">
            <slot name="buttons" />
        </div>
    </div>
    <form
        v-else
        ref="dom"
        role="form"
        class="Form"
        @submit="$emit('submit', $event)"
    >
        <div class="Form__body">
            <slot />
        </div>
        <div v-if="$slots.buttons" class="Form__buttons">
            <slot name="buttons" />
        </div>
    </form>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Ref } from 'vue-property-decorator';

    @Component({
        emits: [ 'submit' ],
    })
    export default class Form extends Vue {
        @Prop({ type: Boolean, default: false })
        private simulated!: boolean;

        @Ref()
        public dom!: HTMLElement;
    }
</script>
